<template lang="html">
  <div class="floorplan-table w-100 mx-5">
    <table class="m-auto">
      <tr>
        <f-th @click.native="sortBy('name')" :sortKey="sortKey"
        headerLabel="name" keySlug="name" :isReverse="reverse"
        class="td-left" />
        <f-th @click.native="sortBy('beds')" :sortKey="sortKey"
        headerLabel="type" keySlug="beds" :isReverse="reverse"
        class="td-left" />
        <f-th @click.native="sortBy('baths')" :sortKey="sortKey"
        headerLabel="baths" keySlug="baths" :isReverse="reverse"
        class="td-right" />
        <f-th @click.native="sortBy('exposure[0]')" :sortKey="sortKey"
        headerLabel="view" keySlug="exposure[0]" :isReverse="reverse"
        class="td-left" />
        <f-th @click.native="sortBy('interior')" :sortKey="sortKey"
        headerLabel="sqft" keySlug="interior" :isReverse="reverse"
        class="td-right" />
        <th></th>
      </tr>
      <transition-group name="row-animate" tag="tbody">
        <tr v-for="floorplan in sortedFloorplanList"
        :key="floorplan.id"
        class="floorplan-table-row row-animate-item text-uppercase">
          <td><floorplan-favourite-toggle :floorplan="floorplan" /></td>
          <td class="td-left">{{ typeLabelLongFromBedsDen(floorplan.beds, floorplan.dens) }}</td>
          <td class="td-right">{{ floorplan.baths }}</td>
          <td class="td-left">{{ floorplan.exposure[0] }}</td>
          <td class="td-right">{{ floorplan.interior }}</td>
          <td>
            <router-link :to="{ name: 'FloorplanDetail', params: { id: floorplan.id }}">
              DETAILS
            </router-link>
          </td>
        </tr>
      </transition-group>
    </table>
  </div>
</template>

<script>
import lodash from 'lodash';
import FloorplanTableHeaderComponent from '@/components/Floorplan/FloorplanTableHeader';
import FloorplanFavouriteToggleComponent from '@/components/Floorplan/FloorplanFavouriteToggle';
import FloorplansMixin from '@/mixins/FloorplansMixin';

export default {
  props: {
    floorplanList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sortKey: 'name',
      reverse: false
    };
  },
  computed: {
    sortedFloorplanList() {
      let ascDesc = 'asc';
      if (!this.reverse) {
        ascDesc = 'desc';
      }
      const sorted = lodash.orderBy(this.floorplanList, this.sortKey, ascDesc);
      return sorted;
    }
  },
  methods: {
    sortBy(column) {
      this.reverse = (this.sortKey === column) ? !this.reverse : false;
      this.sortKey = column;
    }
  },
  components: {
    'f-th': FloorplanTableHeaderComponent,
    'floorplan-favourite-toggle': FloorplanFavouriteToggleComponent
  },
  mixins: [FloorplansMixin]
};
</script>

<style lang="scss" scoped>
.floorplan-table {
  font-family: Scandia-Regular, sans-serif;
  background: white;

  table {
    @media screen and (max-width: $breakpoint-xl) {
      width: 100%;
    }
  }

  th {
    padding: 12px 12px 6px;
    font-weight: 400;
    color: var(--text-dark);
    text-transform: capitalize;

    @media screen and (max-width: $breakpoint-xl) {
      padding: 0 6px;
    }
  }

  td {
    padding: 6px 12px;
    font-family: Scandia-Medium, sans-serif;
    color: black;
    font-size: 1.2rem;

    @media screen and (max-width: $breakpoint-xl) {
      padding: 3px 6px;
    }
  }
}

.floorplan-table-row {
  cursor: pointer;
  background-color: white;
  border-top: 2px solid var(--background);

  &:nth-child(odd) {
    // background: var(--highlight);
  }

  &:hover {
    color: var(--action);
  }
}

.td-left {
  text-align: left;
}

.td-right {
  text-align: right;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/FloorplanTable.vue